import { CardContent } from 'shared-components';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import styles from './settings.module.css';
import classNames from 'classnames';
import { open } from '../modal/modalSlice';
import { toast } from 'react-toastify';
import {
  useDeleteWatermarkMutation,
  useGetWatermarkQuery,
} from './settings.api';
import { Button } from 'shared-components';
import { ButtonIntent, ButtonTier } from 'shared-components';
import { useAppDispatch } from '../../app/hooks';

export const SettingsWatermark = () => {
  const { data, isLoading, isFetching, refetch } = useGetWatermarkQuery();
  const [deleteWatermark] = useDeleteWatermarkMutation();
  const dispatch = useAppDispatch();
  return (
    <CardContent>
      <FormLayout>
        <div className={styles.watermark}>
          <Label>Watermark</Label>
          {isLoading || isFetching ? (
            <span>loading...</span>
          ) : (
            <>
              <div
                className={classNames(styles.watermark__cover, {
                  [styles.watermark__cover_empty]: !data?.url,
                  [styles.watermark__cover_full]: data?.url,
                })}
                style={{
                  backgroundImage: `url(${data?.url})`,
                }}
              ></div>
              <div className={styles.watermark__buttons}>
                {data?.url && (
                  <Button
                    onClick={async () => {
                      if (
                        // eslint-disable-next-line no-restricted-globals
                        confirm('Are you sure you want to clear the watermark?')
                      ) {
                        await deleteWatermark();
                        refetch();
                        toast.success('Watermark cleared');
                      }
                    }}
                    intent={ButtonIntent.Negative}
                    tier={ButtonTier.Secondary}
                  >
                    Clear
                  </Button>
                )}
                <Button
                  className="w-100"
                  onClick={() => {
                    dispatch(
                      open({
                        title: 'Change watermark',
                        contentKey: 'watermark-upload',
                        contentPayload: {},
                      })
                    );
                  }}
                  intent={ButtonIntent.Positive}
                  tier={ButtonTier.Secondary}
                >
                  {data?.url ? 'Change' : 'Upload'}
                </Button>
              </div>
            </>
          )}
        </div>
      </FormLayout>
    </CardContent>
  );
};
